module.exports = __webpack_public_path__ + "media/partner_mo1.0ec3b1dc.mp4";